import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import { getNewLookTokens } from "common/NewLook/tokens";
import { artPalette } from "features/onboarding/art/kit";

/**
 * Colour roles for the walkthrough illustrations. The palette is the
 * onboarding art's (`artPalette`) plus the surfaces taken from the new look's
 * tokens, so the scenes follow dark mode.
 */
export const VizRoot = styled.div`
  ${(p) => artPalette(p.theme)};
  --viz-stop: ${(p) => p.theme.colors.orange};
  --viz-surface: ${(p) => p.theme.colors.cardBgColor};
  --viz-line: ${(p) => getNewLookTokens(p.theme).hairline};
  --viz-tint: ${(p) =>
    p.theme.isDarkMode
      ? hexToRGB("#FFFFFF", 0.06)
      : hexToRGB(p.theme.colors.titleColor, 0.05)};
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  font-family: ${(p) => p.theme.typography.fontFamily};
  font-variant-numeric: tabular-nums;
  color: var(--viz-ink-2);
  line-height: normal;
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  svg text {
    font-family: inherit;
    font-variant-numeric: tabular-nums;
  }
`;
